<template>
  <v-container class="news-form">
    <v-form ref="form" v-model="valid" :lazy-validation="false">
      <v-row>
        <v-col cols="3">標題</v-col>
        <v-col cols="9">
          <v-text-field
            v-model="newsForm.title"
            label="標題"
            :rules="titleRule"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">新聞日期</v-col>
        <v-col cols="9">
          <DateRange
            label="新聞日期"
            v-model="newsForm.newsDate"
            :rules="dateRule"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">媒體</v-col>
        <v-col cols="9">
          <v-select
            v-model="newsForm.mediaId"
            :items="mediaList"
            :rules="mediaRule"
            label="媒體"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">新聞內容</v-col>
        <v-col cols="9">
          <v-textarea
            solo
            v-model="newsForm.newsContent"
            name="input-7-6"
            :rules="contentRule"
            label="新聞內容"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">新聞連結</v-col>
        <v-col cols="9">
          <v-text-field
            v-model="newsForm.newsLink"
            :rules="linkRule"
            label="新聞連結"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">新聞圖片</v-col>
        <v-col cols="4">
          <v-file-input
            :rules="fileRule"
            @click:clear="handleClearImage"
            @change="changeImage($event)"
            accept="image/png, image/jpeg, image/bmp"
            placeholder="上傳圖片"
            prepend-icon="mdi-camera"
            label="新聞圖片"
          ></v-file-input>
        </v-col>
        <v-col cols="5">
          <img :src="newsImage" />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-right">
          <v-btn class="mr-4" @click="handleBack"> 取消 </v-btn>
          <v-btn class="mr-4" @click="handleSubmit"> 確認 </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import api from '@/api';
import imageConvert from '@/utils/image';
import ruleMixin from '@/minix/ruleMixin';
import DateRange from '@/components/DateRange.vue';
import moment from 'moment';

export default {
  mixins: [ruleMixin],
  components: {
    DateRange,
  },
  data() {
    return {
      valid: true,
      newsForm: {
        newsDate: '',
        title: '',
        newsPic: '',
        mediaId: '',
        newsContent: '',
        newsLink: '',
      },
      mediaList: [],
      mediaType: [],
      newsImage: '',
      titleRule: this.requiredRule('標題'),
      dateRule: this.requiredRule('日期'),
      mediaRule: this.requiredRule('媒體'),
      contentRule: this.requiredRule('內容'),
      linkRule: this.requiredRule('連結'),
    };
  },
  async created() {
    await this.getMediaList();
    if (this.isEdit) {
      this.getNewsInfo();
    }
  },
  computed: {
    isEdit() {
      return this.$route.name === 'news-edit';
    },
    newsId() {
      return this.$route.params.newsId;
    },
    fileRule() {
      return [
        (v) => !!v || !!this.newsImage || '圖片 為必填',
        (value) => !value || value.size < 4000000 || '照片大小不可大於 4 MB!',
      ];
    },
  },
  methods: {
    async getMediaList() {
      const { data } = await api.media.mediaList();
      this.mediaType = data;
      this.mediaList = this.mediaType.map((type) => type.mediaName);
    },
    async getNewsInfo() {
      const { data } = await api.news.newsInfo(this.newsId);
      this.newsForm = {
        newsDate: moment(data.newsDate).format('YYYY-MM-DD'),
        title: data.title,
        newsPic: data.newsPic,
        mediaId: this.getMediaName(data.mediaId),
        newsContent: data.newsContent,
        newsLink: data.newsLink,
      };
      this.newsImage = data.newsPic;
    },
    getMediaId(mediaName) {
      const matchMedia = this.mediaType.filter(
        (type) => type.mediaName === mediaName,
      )[0];
      return matchMedia ? matchMedia.mediaId : '';
    },
    getMediaName(mediaId) {
      const matchMedia = this.mediaType.filter(
        (type) => type.mediaId === mediaId,
      )[0];
      return matchMedia ? matchMedia.mediaName : '';
    },
    handleClearImage() {
      this.newsImage = '';
    },
    changeImage(event) {
      if (event) {
        this.newsForm.newsPic = event;
        this.newsImage = URL.createObjectURL(event);
      }
    },
    handleBack() {
      this.$router.push({ name: 'news-list', query: { ...this.$route.query } });
    },
    async handleSubmit() {
      if (!this.$refs.form.validate()) return;
      const hasDate = !!this.newsForm.newsDate;
      const submitForm = {
        ...this.newsForm,
        newsPic: await imageConvert(this.newsForm.newsPic),
        newsDate: hasDate
          ? new Date(this.newsForm.newsDate).toISOString()
          : new Date().toISOString(),
        mediaId: this.getMediaId(this.newsForm.mediaId),
      };
      const { status } = this.isEdit
        ? await api.news.edit({ ...submitForm, newsId: +this.newsId })
        : await api.news.add(submitForm);
      if (status === 1) this.handleBack();
    },
  },
};
</script>

<style scoped lang="scss">
.news-form {
  img {
    width: 100%;
  }
}
</style>
